export default __webpack_public_path__ + "82af08bf7e139f903ac97399a93f1a9c.png";